import mitt from 'mitt'

import type { Events } from './type'

export const uploadManageEvents = mitt<Events>()
